var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#94959B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 9.25L11.8 20.75L7 16.4375",
    fill: "#9597A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9.25L11.8 20.75L7 16.4375",
    stroke: "#C5C5C9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxoff);
export default __webpack_public_path__ + "static/media/checkboxoff.51b3ed00e4cacec5529dfe7c37987896.svg";
export { ForwardRef as ReactComponent };